
import LanguageService from "../../services/configuration/languageService";

export const state = {
    vModel: []
}

export const mutations = {
    SET_CURRENT_DATA(state, newValue) {
        let data ={}
        for( const key in newValue){
            console.log('store')
            console.log(`${key}:${newValue[key]}`)
            data[key]= newValue[key]
        }
        state.vModel.push(data)
        saveState('registration', newValue)
    }
}

export const getters = {
    // Whether the user is currently logged in.
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        //dispatch('validate')
    },
    getInfo() {
        let formattedFilter = {skip:0,take:10,filters:[{
             "field": "string",
             "value": "string"
           }]}
        return LanguageService.getLanguagePaginated(formattedFilter).then((response)=>
         {
             let result = response.data.body.data
             return result
         })
     },
    updateInfo({commit},payload){
        console.log('payload',payload)
        if(payload.id)
        {
            LanguageService.updateLanguage(payload).then((response)=>
            {
                console.log('response',response)
            })
        }
        else{
            LanguageService.addLanguage(payload).then((response)=>
            {
                console.log('response',response)
            })

        }
      
        commit('SET_CURRENT_DATA',payload)
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
